// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { GetFriendsFriendsGetQueryResponse } from "../models/undefinedController/GetFriendsFriendsGet.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getGetFriendsFriendsGetUrl() {
  const res = { method: 'GET', url: `/friends` as const }
  return res
}

/**
 * @summary Get Friends
 * {@link /friends}
 */
export async function getFriendsFriendsGet(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetFriendsFriendsGetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetFriendsFriendsGetUrl().url.toString(), ... requestConfig })
  return res.data
}